import React from 'react';

const conditionButtonIcon = (props) => (
  <svg
    width="206"
    height="215"
    viewBox="0 0 206 215"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.4163 41.4236C82.6092 -4.24221 140.515 -13.4831 177.511 20.3658C214.507 54.2146 216.473 147.636 177.511 188.829C138.549 230.021 48.7492 216.806 18.171 188.829C-12.4072 160.852 -3.77648 87.0895 39.4163 41.4236Z"
      fill={props.color}
    />
  </svg>
);

export default conditionButtonIcon;
